import React, { useContext, useEffect, useRef, useState } from "react";
import { professionalAction } from "../../_actions";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { connect } from "react-redux";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { notificationAction } from "../../_actions/notifications.actions";
import { TablePreventiveNotification } from "../Reports/Tables/preventiveNotificationtable";
import moment from "moment";
const styles = {
  pageContainer: {
    padding: "16px 0",
    width: "100%",
  },
  headerCard: {
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
  },
  filterSection: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-start",
    width: "100%",
  },
  formItem: {
    flex: "1 1 280px",
    minWidth: "280px",
    marginBottom: 0,
  },
  selectInput: {
    width: "100%",
  },
  buttonGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    alignItems: "flex-end",
  },
  actionButton: {
    minWidth: "120px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  viewTypeSection: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    alignItems: "center",
    padding: "12px",
    background: "#f5f5f5",
    borderRadius: "8px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
  },
  totalCount: {
    padding: "4px 12px",
    background: "#fff",
    borderRadius: "4px",
    border: "1px solid #d9d9d9",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100px",
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  },
};

const PreventiveActionsNotSendNotification = (props) => {
  const { Option } = Select;
  console.log("props", props);

  const [download, setDownload] = useState("excel");
  const [city, setCity] = useState(props?.user?.cityId);
  const [data, setData] = useState([]);
  const [count, setCount] = useState();
  const [criminalViewModel, setCriminalViewModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const { language, setLanguage, t } = useContext(LanguageContext);

  const preventiveNotification = (search = searchText) => {
    if (props.user.role === "4") {
      if (searchText) {
        setIsSearch(true);
      }
      let obj = {
        city: props.user.cityId,
      };
      notificationAction
        .getPreventiveActionsNotSendNotification(obj)
        .then((res) => {
          res &&
            res.json().then((criminalList) => {
              console.log("preventive notification", criminalList);
              setData(criminalList.results);
            });
        });
    }
  };
  const onViewAccusedForm = (data) => {
    if (data) {
      props.dispatch(professionalAction.getCriminalsViewsByIdView(data));
      showCriminalViewModel();
    }
  };

  const showCriminalViewModel = () => {
    setCriminalViewModel(true);
  };

  const closeCriminalViewModel = () => {
    setCriminalViewModel(false);
  };

  const [form] = Form.useForm();
  const [formDownload] = Form.useForm();
  const downloadReport = (download) => {
    console.log("test", download);
    if (download == "excel") {
      console.log("test");
      var ReportTitle = "Preventive_Notification_Report";
      var ShowLabel = true;
      var arrData = data;
      var list = [];
      var CSV = "";

      list = arrData.map((data, index) => ({
        "अ.क्र.": index + 1,
        "आरोपीचे नाव": data.basic_name,
        "चालू प्र. कारवाई ": data.preventive_action_name,
        पासून: moment(data.date_form).format("DD/MM/YYYY"),
        "पर्यन्त ": moment(data.date_to).format("DD/MM/YYYY"),
        "गुन्ह्याचे पो. स्टे": data.guna_districtName,
        "दरम्यान दाखल गुन्हा": moment(data.gunha_dateTime).format("DD/MM/YYYY"),
        "कायदा कलम ": `${data?.kalam || ""} ,${data?.rulesName || ""}`,
      }));

      if (ShowLabel) {
        var row = "";
        for (var index in list[0]) {
          row += '"' + index + '",';
        }
        row = row.slice(0, -1);
        CSV += row + "\r\n";
      }

      for (var i = 0; i < list.length; i++) {
        var row = "";
        for (var index in list[i]) {
          row += '"' + String(list[i][index]).replace(/"/g, '""') + '",';
        }
        row = row.slice(0, -1);
        CSV += row + "\r\n";
      }

      if (CSV === "") {
        alert("Invalid data");
        return;
      }

      var fileName = ReportTitle.replace(/ /g, "_");

      var uri = "data:text/csv;charset=utf-8,\uFEFF" + encodeURIComponent(CSV);
      var link = document.createElement("a");
      link.href = uri;

      link.style = "visibility:hidden";
      link.download = fileName + ".xls";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  //
  const [searchText, setSerachText] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  useEffect(() => {
    preventiveNotification();
  }, [searchText]);

  const clearFilters = () => {
    setSerachText(null);
    setIsSearch(false);
    preventiveNotification(null);
  };
  return (
    <>
      <div
        className="filter-row"
        style={{
          padding: "16px 20px",
          background: "#fff",
          borderRadius: "8px",
          border: "1px solid #f0f0f0",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between", // Aligns children (total count and button) to opposite ends
            alignItems: "center",
            gap: "16px",
            flexWrap: "nowrap",
          }}
          className="button-group-responsive"
        >
          {/* Total Count Section */}
          <div style={styles.totalCount}>
            <span style={{ color: "#666" }}>{t("total")}:</span>
            <span style={{ fontWeight: "bold" }}>
              {data.length > 0 ? data.length : 0}
            </span>
          </div>

          {/* Close Button Section */}
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <Button
              className="modern-button modern-button-close"
              onClick={() => {
                props.closeWanted();
              }}
            >
              <CloseCircleFilled />
            </Button>
          </div>
        </div>
      </div>

      <TablePreventiveNotification
        data={data}
        key={data}
        allTotal={count}
        total={count}
        onViewAccusedForm={onViewAccusedForm}
        loading={loading}
      />
      {/* {visible && (
        <div id="pdf-content" style={{ padding: 20, background: "#fff" }}>
          <Table
            columns={columnsToShow}
            dataSource={data}
            pagination={false}
            bordered
            style={{ fontSize: "18px" }}
          />
        </div>
      )} */}

      <Modal
        title="आरोपी प्रोफाइल"
        top
        visible={criminalViewModel}
        onOk={closeCriminalViewModel}
        onCancel={closeCriminalViewModel}
        width={95 + "%"}
      >
        <ViewFormModel dataStates={props?.professionals}></ViewFormModel>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedWanted = connect(mapStateToProps)(
  PreventiveActionsNotSendNotification
);
export { connectedWanted as PreventiveActionsNotSendNotificationList };
